module.exports = __webpack_public_path__ + "img/img2.587a3ee9.png";